import React from 'react';
import PropTypes from 'prop-types';

const BudgetIcon = ({ dashArray, dashOffset, opacity, showStar }) => {
  return (
    <svg
      width="192"
      height="192"
      viewBox="0 0 192 192"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_7014_191887)">
        <circle cx="96" cy="92" r="80" fill="white" />
        <circle
          cx="96"
          cy="92"
          r="77"
          stroke={showStar ? '#E4E5E7' : 'white'}
          strokeWidth="6"
        />
      </g>
      <circle
        className="progressBar"
        cx="96"
        cy="92"
        r="77"
        fill="transparent"
        strokeWidth="6"
        stroke="#FFC50A"
        strokeDasharray={dashArray || ''}
        strokeDashoffset={dashOffset || ''}
        strokeLinecap="butt"
      />
      <circle cx="96" cy="92" r="65" fill="#E2F7FF" />
      <g opacity={opacity} clipPath="url(#clip0_7014_191887)">
        <path
          d="M92.8631 93.0908V60.2783C92.8631 59.7076 92.3947 59.2185 91.8042 59.2389C71.7458 59.8299 55.9435 77.3979 58.2242 98.084C59.9959 114.083 72.9066 127.004 88.8922 128.777C109.561 131.06 127.115 115.244 127.706 95.1696C127.706 94.599 127.237 94.1098 126.667 94.1098H93.8813C93.3111 94.1098 92.8631 93.6615 92.8631 93.0908Z"
          fill="#352269"
        />
        <path
          d="M133 87.8111C132.45 69.3872 117.625 54.5503 99.1961 54C98.6259 54 98.1372 54.4687 98.1372 55.0394V87.8519C98.1372 88.4226 98.5852 88.8709 99.1554 88.8709H131.941C132.511 88.8709 133 88.4022 132.98 87.8111H133Z"
          fill="#00B0AC"
        />
      </g>
      {showStar && <circle cx="96" cy="19" r="15" fill="#FFC50A" />}
      <path
        d="M94.064 16.621L95.4667 13.7787C95.6501 13.4071 96.18 13.4071 96.3634 13.7787L97.7661 16.621L100.902 17.0762C101.312 17.1357 101.476 17.6397 101.179 17.929L98.9103 20.1415L99.4459 23.2655C99.5159 23.674 99.0871 23.9855 98.7203 23.7925L95.9151 22.317L93.1098 23.7925C92.743 23.9855 92.3142 23.674 92.3842 23.2655L92.9198 20.1415L90.651 17.929C90.3543 17.6397 90.5181 17.1357 90.9282 17.0762L94.064 16.621Z"
        fill="white"
      />
      <defs>
        <filter
          id="filter0_d_7014_191887"
          x="0"
          y="0"
          width="192"
          height="192"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="8" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_7014_191887"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_7014_191887"
            result="shape"
          />
        </filter>
        <clipPath id="clip0_7014_191887">
          <rect
            width="75"
            height="75"
            fill="white"
            transform="translate(58 54)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

BudgetIcon.propTypes = {
  percentage: PropTypes.string,
};

BudgetIcon.defaultProps = {
  percentage: '0%',
};

export default BudgetIcon;
